import { render, staticRenderFns } from "./tagihan.vue?vue&type=template&id=03806018"
import script from "./tagihan.vue?vue&type=script&lang=js"
export * from "./tagihan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports